<template>
  <div class="vipWps" >
    <div class="bitmap">
      <img src="./images/wps/image-01.jpg" class="bitmap" alt="">
    </div>
    <div class="vipWps-bar"  ref="tabSwiper">
      <img src="./images/wps/bar.png" alt="" class="vipWps-bar-bg">
      <swiper class="vipWps-bar-swiper" :options="tabSwiperOptions">
        <swiper-slide v-for="(item, index) in categories" :key="`listTab${index}`" :ref="`tab${index}`">
          <a class="vipWps-bar-swiper-item"
             :class="{'active': categoryIndex === index}"
             @click="toCategory(index)"
             :href="item.href">
            {{`${item.title}`}}
          </a>
        </swiper-slide>
        <!--<div class="list-tab-swiper-scrollbar" ref="drag" />-->
      </swiper>
    </div>
    <div class="vipWps-bar fixedTab" v-show="isTabFixed">
      <img src="./images/wps/bar.png" alt="" class="vipWps-bar-bg">
      <swiper class="vipWps-bar-swiper" :options="tabSwiperOptions">
        <swiper-slide v-for="(item, index) in categories" :key="`listTab${index}`" :ref="`tab${index}`">
          <a class="vipWps-bar-swiper-item"
             :class="{'active': categoryIndex === index}"
             @click="toCategory(index)"
             :href="item.href">
            {{`${item.title}`}}
          </a>
        </swiper-slide>
      </swiper>
    </div>
    <div class="vipWps-shelf">
      <div class="vipWps-shelf-apiece" v-for="(item, index) in vipOperationList" :key="index" :id="categoriesLink[index].routeId" v-if="index < 6">
        <img src="./images/wps/table.jpg" alt="" class="vipWps-shelf-apiece-bg">
        <div class="vipWps-shelf-apiece-main">
          <img class="title" :src="titleImages[index]" alt="">
          <ul class="courses">
            <li v-for="(itm, i) in item.vipShowCourseList" v-if="i < 3" @click="toSignUp(itm)" :key="i">
              <CourseItem :courseInfo="itm"></CourseItem>
            </li>
            <li @click="toList(item.type)" class="link" v-if="index < 6">{{categoriesLink[index].content}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bottom-image">
      <img src="./images/wps/image-02.jpg" class="bitmap" alt="">
    </div>
    <div class="sign" @click="buy" v-if="signStatus !== 2">
      <div class="sign-desc">
        <p>{{firstPrice}}</p>
        <p class="price" v-if="firstPrice !== price">第二个月自动续费￥{{price}}/月</p>
      </div>
      <img src="./images/wps/sign.jpg" alt="">
    </div>
    <div v-else class="sign hasBuy-btn" @click="$router.push('/recommend')"></div>
  </div>
</template>

<script>
  import './style.scss'
  import keys from 'lodash.keys'
  import os from '@edu-fe/os'
  import api from '@edu-fe/api'
  import module from '../../modules/vip/vip'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import Notice from '../../components/Notice'
  import login from "@/utils/login";
  import CourseItem from "../../components/Vip/VipCourseItem"
  import SignInfo from '../../lib/signInfo'
  export default {
    data () {
      return {
        firstPrice: 69,
        price: 58,
        categoryIndex: 0,
        isTabFixed: false,
        tabSwiperOptions: {
          slidesPerView: 'auto',
          spaceBetween: 30,
          slidesOffsetBefore: 27,
          slidesOffsetAfter: 27,
          freeMode: true
        },
        categories: [{
          href: '#category1',
          title: 'WPS技巧'
        }, {
          href: '#category2',
          title: '情商&沟通'
        }, {
          href: '#category3',
          title: '个人提升'
        }, {
          href: '#category4',
          title: '赚钱&理财'
        }, {
          href: '#category5',
          title: '亲子&兴趣'
        }, {
          href: '#category6',
          title: '有声书'
        }],
        categoriesLink: [{
          content: '更多290+办公技巧，立即获取>>',
          routeId: 'category1'
        }, {
          content: '更多25+沟通技巧，立即获取>> ',
          routeId: 'category2'
        }, {
          content: '更多30+个人技巧，立即获取>>',
          routeId: 'category3'
        },  {
          content: '更多30+赚钱门路，立即获取>>',
          routeId: 'category4'
        }, {
          content: '更多25+有趣课程，立即获取>> ',
          routeId: 'category5'
        }, {
          content: '更多50+有声书，立即获取>>',
          routeId: 'category6'
        }],
        titleImages: [
          require('./images/wps/title-1.png'),
          require('./images/wps/title-2.png'),
          require('./images/wps/title-3.png'),
          require('./images/wps/title-4.png'),
          require('./images/wps/title-5.png'),
          require('./images/wps/title-6.png')
        ]
      }
    },
    computed: {
      ...mapState(module.name, keys(module.state())),
      ...mapGetters(module.name, keys(module.getters)),
      ...mapState(['vipOperationList']),
    },
    watch: {
      cardList: {
        handler (val) {
          if (!val.length) return
          this.firstPrice = val[0].firstPrice
          this.price =  val[0].price
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      ...mapMutations(module.name, keys(module.mutations)),
      ...mapActions(module.name, keys(module.actions)),
      toSignUp (item) {
        this.$router.push({
          path: '/sign-up',
          query: {
            courseId: item.id
          }
        })
      },
      toList (type) {
        this.$router.push({
          path: '/list',
          query: {
            type: 1,
            operation: type
          }
        })
      },
      toCategory (index) {
        this.categoryIndex = index
      },
      pull () {
        let tabTop = this.$refs.tabSwiper.offsetTop
        let tabHeight = this.$refs.tabSwiper.offsetHeight
        window.addEventListener('scroll', () => {
          let windowScrollTop = document.documentElement.scrollTop || document.body.scrollTop
          if (tabTop + tabHeight < windowScrollTop) {
            this.isTabFixed = true
          } else {
            this.isTabFixed = false
          }
        })
      },
      topage (courseId) {
        this.$router.push({
          path: '/sign-up',
          query: {
            courseId,
            from: 'H5_vip_card',
          }
        })
      },
      async buy () {
        await login.login()
        SignInfo.sign({
          cardType: 1,
          from: this.$route.query.from
        })
      },
    },
    beforeCreate () {
      this.$store.registerModule(module.name, module)
    },
    created () {
      this.init()
    },
    mounted () {
      this.pull()
    },
    beforeDestroy () {
      this.$store.unregisterModule(module.name)
    },
    components: {
      // VipHead,
      // VipShowCase: RecommendShowcase,
      // VipChoice,
      Notice,
      CourseItem
    }
  }
</script>
<style lang="scss" scoped>
  @charset "UTF-8";
  @import "../../style/main";
  .vipWps {
    font-size: 0;
    /*overflow: scroll;*/
    padding-bottom: rem(50);
    background: #aa1020;
    .bitmap {
      width: 100%;
      min-height: rem(582);
      > img {
        width: 100%;
      }
    }
    &-bar {
      position: relative;
      z-index: 1;
      &-bg {
        width: 100%;
      }

      &-swiper {
        font-size: rem(30);
        line-height: rem(42);
        position: absolute;
        color: #fff;
        top: rem(21);
        .swiper-slide {
          width: auto;
        }
        &-item {
          font-weight: bold;
        }
        .active {
          background: linear-gradient(to bottom, #FFFDEC, #FFE091);
          -webkit-background-clip: text;
          color: transparent;
          font-weight: bolder;
          &:after {
            content: '';
            display: block;
            width: rem(36);
            height: rem(8);
            background: #FFFBD4;
            margin: auto;
            border-radius: rem(10);
          }
        }
      }
    }
    .fixedTab {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 99;
    }
    &-shelf {
      position: relative;
      top: rem(-35);
      &-apiece {
        position: relative;
        &-bg {
          width: 100%;
        }
        &-main {
          position: absolute;
          top: 0;
          padding-top: rem(110);
          text-align: center;
          width: 100%;
          .title {
            width: rem(319);
            margin-bottom: rem(56);
          }
          .courses {
            width: rem(700);
            height: rem(880);
            margin: 0 auto;
            background: #F8F8EE;
            border-radius: rem(10);
            padding: 0 rem(44);
            box-sizing: border-box;
            > li {
              padding: rem(30) 0;
              border-bottom: 1px solid #E7E5E4;
            }
          }
          .link {
            font-size: rem(30);
            color: #E66C5A;
            font-weight: bolder;
            border-bottom: none ;
          }
        }
      }
    }
    .bottom-image {
      width: 100%;
      position: relative;
      top: rem(-35);
      > img {
        width: 100%;
      }
    }
    .sign {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      > img {
        width: 100%;
      }
      &-desc {
        position: absolute;
        top: 50%;
        left: rem(24);
        transform: translateY(-50%);
        > p {
          &:first-child {
            &:before {
              content: '￥';
              font-size: rem(42);
            }
            background: linear-gradient(to bottom, transparent 0%, #fff 1%, #FFE19C);
            -webkit-background-clip: text;
            color: transparent;
            font-size: rem(80);
            font-weight: bold;
          }
        }
        .price {
          font-size: rem(18);
          color: #FFECEC;
        }
      }
    }
    .hasBuy-btn {
      width: 100%;
      height: rem(140);
      background-image: url('images/activity/hasBuy.jpg') ;
      background-size: cover;
    }
  }
</style>
